export default "__VITE_ASSET__123d2963__"